import { cx } from '@twind/core';
import React from 'react';
import useFooterLinks from 'app/hooks/useFooterLinks';
import useLogo from 'app/modules/live-chat/hooks/useLogo';

import { Copy } from '../../../components/Typography';
import useLinks from '../hooks/useLinks';
import useTailorTracking from '../hooks/useTailorTracking';

export default function TailorFooter() {
  const { captureFooterLinkClick, captureLandingPageLogoClicked } = useTailorTracking();
  const { openLink, getLinkTarget } = useLinks();

  const logo = useLogo();
  const { primaryFooterLink: footerLink } = useFooterLinks();
  const showFooterLink = footerLink?.show;

  const handleFooterLinkClick = (event: React.MouseEvent) => {
    event.preventDefault();
    captureFooterLinkClick(footerLink);
    if (footerLink?.link) {
      openLink(footerLink.link, { action_type: footerLink?.action_type, linkLocation: 'footer' });
    }
  };

  const handleLogoClick = (event: React.MouseEvent) => {
    event.preventDefault();
    captureLandingPageLogoClicked(logo.logoLink);
    if (logo.logoLink) {
      openLink(logo.logoLink);
    }
  };

  if (!logo.logoUrl) {
    return null;
  }

  return (
    <footer
      id="ostro-tailor-footer-container"
      className="flex flex-row items-center justify-between p-5 bg-white"
    >
      <div className={cx(showFooterLink ? 'text-left' : 'text-center grow')}>
        {logo.logoLink ? (
          <a
            onClick={handleLogoClick}
            href={logo.logoLink}
            target={getLinkTarget(logo.logoLink)}
            rel="noreferrer"
            className="flex min-h-[24px] items-center"
          >
            <img
              src={logo.logoUrl}
              alt="Logo"
              className="inline max-w-[110px]"
            />
          </a>
        ) : (
          <img
            src={logo.logoUrl}
            alt="Logo"
            className="inline max-w-[110px]"
          />
        )}
      </div>
      {showFooterLink && (
        <div className="flex">
          <Copy
            id="ostro-tailor-footer-link-primary"
            onClick={handleFooterLinkClick}
            component="a"
            href={footerLink?.link}
            target={getLinkTarget(footerLink?.link)}
            className="flex items-center min-h-[24px] items-center"
          >
            <img
              alt="Footer Link Brand Logo"
              src={footerLink?.logo}
              className="inline w-3 h-3 mr-1"
            />
            {footerLink?.text}
          </Copy>
        </div>
      )}
    </footer>
  );
}
